(function () {
  'use strict';

  if (window.SMSWishlist && typeof window.SMSWishlist.refresh === 'function') {
    window.SMSWishlist.refresh();
    return;
  }

  var storageKey = 'sms-storefront-wishlist-v1';
  var legacyStorageKey = 'smsWishlist';
  var memoryItems = [];
  var productCache = Object.create(null);
  var hydrationInFlight = Object.create(null);

  function cleanString(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normalizeItem(item) {
    if (!item || typeof item !== 'object') return null;

    var handle = cleanString(item.handle);
    if (!handle) return null;

    return {
      id: cleanString(item.id),
      handle: handle,
      variantId: cleanString(item.variantId),
      title: cleanString(item.title) || handle,
      url: cleanString(item.url) || '/products/' + encodeURIComponent(handle),
      image: cleanString(item.image),
      price: cleanString(item.price),
      addedAt: cleanString(item.addedAt)
    };
  }

  function normalizeItems(items) {
    if (!Array.isArray(items)) return [];

    var handles = Object.create(null);

    return items.reduce(function (result, item) {
      var normalized = normalizeItem(item);
      if (!normalized || handles[normalized.handle]) return result;
      handles[normalized.handle] = true;
      result.push(normalized);
      return result;
    }, []);
  }

  function normalizeHandles(items) {
    if (!Array.isArray(items)) return [];

    var handles = Object.create(null);

    return items.reduce(function (result, item) {
      var handle = cleanString(typeof item === 'string' ? item : item && item.handle);
      if (!handle || handles[handle]) return result;
      handles[handle] = true;
      result.push(handle);
      return result;
    }, []);
  }

  function read() {
    try {
      var stored = window.localStorage.getItem(storageKey);
      memoryItems = normalizeItems(stored ? JSON.parse(stored) : []);
    } catch (error) {
      memoryItems = normalizeItems(memoryItems);
    }

    return memoryItems.slice();
  }

  function readLegacyHandles() {
    try {
      var stored = window.localStorage.getItem(legacyStorageKey);
      return normalizeHandles(stored ? JSON.parse(stored) : []);
    } catch (error) {
      return [];
    }
  }

  function writeLegacyHandles(handles) {
    try {
      window.localStorage.setItem(legacyStorageKey, JSON.stringify(normalizeHandles(handles)));
    } catch (error) {
      // Keep the richer in-memory wishlist usable when browser storage is unavailable.
    }
  }

  function write(items) {
    memoryItems = normalizeItems(items);

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(memoryItems));
    } catch (error) {
      memoryItems = normalizeItems(memoryItems);
    }

    writeLegacyHandles(memoryItems.map(function (item) {
      return item.handle;
    }));

    window.dispatchEvent(new CustomEvent('sms:wishlist-change', {
      detail: memoryItems.slice()
    }));

    return memoryItems.slice();
  }

  function hasHandle(items, handle) {
    return items.some(function (item) {
      return item.handle === handle;
    });
  }

  function hasLegacyHandle(handle) {
    return readLegacyHandles().indexOf(handle) !== -1;
  }

  function updateCounts(items) {
    document.querySelectorAll('[data-sms-wishlist-count]').forEach(function (count) {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
      count.setAttribute('aria-label', items.length + (items.length === 1 ? ' saved product' : ' saved products'));
    });

    document.querySelectorAll('[data-wishlist-summary]').forEach(function (summary) {
      summary.textContent = items.length + (items.length === 1 ? ' saved product' : ' saved products');
    });

    document.querySelectorAll('[data-wishlist-clear]').forEach(function (button) {
      button.disabled = items.length === 0;
    });
  }

  function updateButtons(items) {
    document.querySelectorAll('[data-sms-wishlist-add]').forEach(function (button) {
      var handle = cleanString(button.dataset.productHandle);
      var title = cleanString(button.dataset.productTitle) || 'this product';
      var saved = hasHandle(items, handle);

      button.classList.toggle('is-saved', saved);
      button.textContent = saved ? '♥' : '♡';
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? 'Remove ' + title + ' from wishlist' : 'Save ' + title + ' to wishlist');
      button.setAttribute('title', saved ? 'Remove from wishlist' : 'Save to wishlist');
    });

    document.querySelectorAll('.wishList[data-product-handle]').forEach(function (button) {
      var saved = hasHandle(items, cleanString(button.dataset.productHandle));
      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', String(saved));
    });

    document.querySelectorAll('.header_whishlist_icon').forEach(function (button) {
      button.classList.toggle('has-items', items.length > 0);
    });
  }

  function createLink(className, href, text) {
    var link = document.createElement('a');
    link.className = className;
    link.href = href;
    link.textContent = text;
    return link;
  }

  function createWishlistCard(item) {
    var article = document.createElement('article');
    var imageLink = createLink('smsWishlistImage', item.url, '');
    var content = document.createElement('div');
    var heading = document.createElement('h2');
    var price = document.createElement('strong');
    var actions = document.createElement('div');
    var remove = document.createElement('button');

    article.className = 'smsWishlistCard';

    if (item.image) {
      var image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      image.width = 600;
      image.height = 600;
      imageLink.appendChild(image);
    } else {
      var imageFallback = document.createElement('span');
      imageFallback.className = 'smsWishlistImageFallback';
      imageFallback.textContent = 'Product image unavailable';
      imageLink.appendChild(imageFallback);
    }

    heading.appendChild(createLink('', item.url, item.title));
    price.textContent = item.price;
    content.appendChild(heading);
    content.appendChild(price);

    actions.className = 'smsWishlistActions';
    actions.appendChild(createLink('', item.url, 'View product'));

    remove.type = 'button';
    remove.dataset.removeHandle = item.handle;
    remove.setAttribute('aria-label', 'Remove ' + item.title + ' from wishlist');
    remove.textContent = 'Remove';
    actions.appendChild(remove);

    article.appendChild(imageLink);
    article.appendChild(content);
    article.appendChild(actions);
    return article;
  }

  function renderPage(items) {
    document.querySelectorAll('[data-sms-wishlist-page]').forEach(function (page) {
      var grid = page.querySelector('[data-wishlist-grid]');
      var empty = page.querySelector('[data-wishlist-empty]');
      if (!grid || !empty) return;

      grid.replaceChildren();
      grid.hidden = items.length === 0;
      empty.hidden = items.length > 0;

      items.forEach(function (item) {
        grid.appendChild(createWishlistCard(item));
      });
    });
  }

  function announce(message) {
    document.querySelectorAll('[data-sms-wishlist-status]').forEach(function (status) {
      status.textContent = '';
      window.requestAnimationFrame(function () {
        status.textContent = message;
      });
    });
  }

  function itemFromButton(button) {
    return normalizeItem({
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      variantId: button.dataset.variantId,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      addedAt: new Date().toISOString()
    });
  }

  function itemFromHandle(handle) {
    return normalizeItem({
      handle: handle,
      addedAt: new Date().toISOString()
    });
  }

  function getLocaleRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function formatMoney(cents) {
    var amount = Number(cents) / 100;
    var locale = document.documentElement.lang || 'en-US';
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';

    if (!Number.isFinite(amount)) return '';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function itemFromProduct(product, existingItem) {
    if (!product || typeof product !== 'object') return null;

    var variants = Array.isArray(product.variants) ? product.variants : [];
    var variant = variants.find(function (candidate) {
      return candidate && candidate.available;
    }) || variants[0] || null;
    var handle = cleanString(product.handle) || (existingItem && existingItem.handle);
    var image = cleanString(product.featured_image)
      || cleanString(Array.isArray(product.images) ? product.images[0] : '');

    return normalizeItem({
      id: product.id == null ? '' : String(product.id),
      handle: handle,
      variantId: variant && variant.id != null ? String(variant.id) : '',
      title: cleanString(product.title) || (existingItem && existingItem.title),
      url: cleanString(product.url) || getLocaleRoot() + 'products/' + encodeURIComponent(handle),
      image: image,
      price: formatMoney(variant ? variant.price : product.price),
      addedAt: existingItem && existingItem.addedAt
        ? existingItem.addedAt
        : new Date().toISOString()
    });
  }

  function needsHydration(item) {
    return item.title === item.handle
      || (!item.image && !item.price && !item.variantId);
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (hydrationInFlight[handle]) return hydrationInFlight[handle];

    var request = window.fetch(
      getLocaleRoot() + 'products/' + encodeURIComponent(handle) + '.js',
      { headers: { Accept: 'application/json' } }
    ).then(function (response) {
      if (!response.ok) throw new Error('Unable to load product ' + handle);
      return response.json();
    }).then(function (product) {
      productCache[handle] = product;
      delete hydrationInFlight[handle];
      return product;
    }, function (error) {
      delete hydrationInFlight[handle];
      throw error;
    });

    hydrationInFlight[handle] = request;
    return request;
  }

  function hydrateItems(items) {
    var refreshFullProductData = Boolean(document.querySelector('[data-sms-wishlist-page]'));

    normalizeItems(items).filter(function (item) {
      return refreshFullProductData || needsHydration(item);
    }).forEach(function (item) {
      fetchProduct(item.handle).then(function (product) {
        var hydrated = itemFromProduct(product, item);
        if (!hydrated) return;

        var currentItems = read();
        if (!hasHandle(currentItems, item.handle)) return;

        write(currentItems.map(function (currentItem) {
          return currentItem.handle === item.handle ? hydrated : currentItem;
        }));
      }).catch(function () {
        // Keep the saved handle visible even if a product is unavailable.
      });
    });
  }

  function importLegacyWishlist() {
    var items = read();

    readLegacyHandles().forEach(function (handle) {
      if (!hasHandle(items, handle)) items.push(itemFromHandle(handle));
    });

    items = write(items);
    hydrateItems(items);
    return items;
  }

  function reconcileHandleFromLegacy(handle) {
    var normalizedHandle = cleanString(handle);
    if (!normalizedHandle) return read();

    var items = read();
    var savedInLegacy = hasLegacyHandle(normalizedHandle);
    var savedInPage = hasHandle(items, normalizedHandle);

    if (savedInLegacy && !savedInPage) {
      items.unshift(itemFromHandle(normalizedHandle));
      items = write(items);
      hydrateItems(items);
      return items;
    }

    if (!savedInLegacy && savedInPage) {
      return write(items.filter(function (item) {
        return item.handle !== normalizedHandle;
      }));
    }

    refresh(items);
    hydrateItems(items);
    return items;
  }

  function reconcileAllFromLegacy() {
    var currentItems = read();
    var nextItems = readLegacyHandles().map(function (handle) {
      return currentItems.find(function (item) {
        return item.handle === handle;
      }) || itemFromHandle(handle);
    });

    nextItems = write(nextItems);
    hydrateItems(nextItems);
    return nextItems;
  }

  function add(item) {
    var normalized = normalizeItem(item);
    if (!normalized) return read();

    var items = read().filter(function (savedItem) {
      return savedItem.handle !== normalized.handle;
    });

    items.unshift(normalized);
    return write(items);
  }

  function remove(handle) {
    var normalizedHandle = cleanString(handle);
    return write(read().filter(function (item) {
      return item.handle !== normalizedHandle;
    }));
  }

  function toggle(item) {
    var normalized = normalizeItem(item);
    if (!normalized) return { saved: false, items: read() };

    var items = read();
    var saved = hasHandle(items, normalized.handle);
    var nextItems = saved
      ? items.filter(function (savedItem) { return savedItem.handle !== normalized.handle; })
      : [normalized].concat(items);

    return {
      saved: !saved,
      items: write(nextItems)
    };
  }

  function clear() {
    return write([]);
  }

  function refresh(items) {
    var currentItems = Array.isArray(items) ? normalizeItems(items) : read();
    updateCounts(currentItems);
    updateButtons(currentItems);
    renderPage(currentItems);
    return currentItems;
  }

  window.SMSWishlist = {
    version: '3.1.0',
    storageKey: storageKey,
    legacyStorageKey: legacyStorageKey,
    getItems: read,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    refresh: refresh
  };

  document.addEventListener('click', function (event) {
    var legacyButton = event.target.closest('.cstm_whislist_icon.wishList[data-product-handle]');
    var legacyRemoveButton = event.target.closest('.DeleteFromList[data-product-handle]');
    var changedHandle = legacyButton
      ? legacyButton.dataset.productHandle
      : legacyRemoveButton && legacyRemoveButton.dataset.productHandle;

    if (!changedHandle) return;

    window.setTimeout(function () {
      reconcileHandleFromLegacy(changedHandle);
    }, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-sms-wishlist-add]');

    if (addButton) {
      event.preventDefault();
      var product = itemFromButton(addButton);
      var result = toggle(product);
      announce(result.saved ? product.title + ' was saved to your wishlist.' : product.title + ' was removed from your wishlist.');
      return;
    }

    var legacyButton = event.target.closest('.cstm_whislist_icon.wishList[data-product-handle]');

    if (legacyButton) {
      if (!window.__smsWishlistInit) {
        event.preventDefault();
        event.stopPropagation();
        var fallbackResult = toggle(itemFromHandle(legacyButton.dataset.productHandle));
        hydrateItems(fallbackResult.items);
      }
      return;
    }

    var standaloneLegacyButton = event.target.closest('.wishList[data-product-handle]');

    if (standaloneLegacyButton) {
      event.preventDefault();
      event.stopPropagation();
      var standaloneResult = toggle(itemFromHandle(standaloneLegacyButton.dataset.productHandle));
      hydrateItems(standaloneResult.items);
      return;
    }

    var removeButton = event.target.closest('[data-remove-handle]');

    if (removeButton) {
      event.preventDefault();
      remove(removeButton.dataset.removeHandle);
      announce('Product removed from your wishlist.');
      return;
    }

    if (event.target.closest('[data-wishlist-clear]')) {
      event.preventDefault();
      clear();
      announce('Your wishlist was cleared.');
    }
  });

  window.addEventListener('sms:wishlist-change', function (event) {
    refresh(event.detail);
  });

  window.addEventListener('storage', function (event) {
    if (!event.key) {
      importLegacyWishlist();
    } else if (event.key === legacyStorageKey) {
      reconcileAllFromLegacy();
    } else if (event.key === storageKey) {
      var items = read();
      writeLegacyHandles(items.map(function (item) {
        return item.handle;
      }));
      refresh(items);
      hydrateItems(items);
    }
  });

  document.addEventListener('shopify:section:load', function () {
    importLegacyWishlist();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      importLegacyWishlist();
    });
  } else {
    importLegacyWishlist();
  }
}());
